<div class="main-content-container">
  <div class="main-container-body" style="background-color: transparent;">
    <div [ngClass]="utilService.isMobile()?'tracksampledotmob':'tracksampledot'">
      <div class="text-capitalize" [ngClass]="utilService.isMobile()?'_wf-sdts-allpointstop':'_wf-dts-navpoints'">
        <div [ngClass]="utilService.isMobile()?'_wf-dts-mob':'_wf-dts-rgtpoints'">
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <div class="text-block-230"><i class="fa fa-circle pending"></i></div>
            <div class="text-block-231">Pending</div>
          </div>
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <i class="fa fa-circle completed"></i>
            <div class="text-block-231">Completed</div>
          </div>
          @if (checkCancelStatus()) {
            <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
              <i class="fa fa-circle cancelled"></i>
              <div class="text-block-231">Cancelled</div>
            </div>
          }
          <div [ngClass]="utilService.isMobile()?'_wf-sbts-trackfirstpoint':'_wf-dts-firstpoint'">
            <i class="fa fa-circle NA"></i>
            <div class="text-block-231">NA</div>
          </div>
          @if (GridData && _currentData && _currentData.resouceDef.config.tile && _currentData.resouceDef.config.table) {
            <div class="table-view-toggle">
              <ng-template #swithcToCard>
                Switch Card Layout
              </ng-template>
              <ng-template #swithcToTable>
                Switch Table Layout
              </ng-template>
              <span class="toggle-icn">
                @if (dataGridConfig.activeField == 'table') {
                  <i  class="fa fa-th"
                  (click)="switchView('tile');" [popover]="swithcToCard" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
                }
                @if (dataGridConfig.activeField == 'tile') {
                  <i class="fa fa-list"
                  (click)="switchView('table');" [popover]="swithcToTable" placement="left" container="body" containerClass="info-popover" triggers="mouseenter:mouseleave"></i>
                }
              </span>
            </div>
          }
        </div>
      </div>

      @if (GridData && _currentData.finalKeys) {
        <dhs-data-grid [data]="GridData"
          [fields]="_currentData.finalKeys" [config]="dataGridConfig" [bulkActionsConfig]="_currentData.bulkAction" (configValues)="getConfigValues($event)" (onLimitChange)="onLimit($event)"
          (onPageChanges)="onPageChanged($event)"  (editEllipseClick)="redirect($event)"
          (bulkActionClicked)="onBulkActionClicked($event)"
          (onFilterChange)="filterClick($event)" (onSortChanges)="sortChanges($event);"
          [filterFieldGroup]="hasFilterBlocks() ? _currentData : undefined" (bindGrid)="bindDataToGrid($event)">
        </dhs-data-grid>
      }
    </div>
  </div>
</div>